import { Component, OnInit, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  UntypedFormGroup,
  FormGroup,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { SessionStorageService } from '../services/session-storage.service';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { HasPermissionDirective } from '../directives/permissions.directive';

@Component({
  selector: 'app-report-dialog',
  templateUrl: './report-dialog.component.html',
  styleUrls: ['./report-dialog.component.scss'],
  imports: [
    MatDialogModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    HasPermissionDirective,
  ],
})
export class ReportDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ReportDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private ss = inject(SessionStorageService);

  form: FormGroup;
  hideDetails: boolean =
    this.data && this.data.hideDetails ? this.data.hideDetails : false;
  hideVaDetails: boolean = this.data ? this.data.hideVaDetails : true;
  includeNotes: boolean = this.data ? this.data.showNotes : false;
  existingNotes: string = this.data ? this.data.existingNotes : false;
  app;
  beforePrintPrompt;
  hintText =
    'Enter a filename here if you would like to personalize the file. Otherwise the system will generate one for you.';
  notesPlaceholder = 'Additional Notes';

  ngOnInit() {
    this.app = this.ss.get('currentApp');

    const formGroup = new UntypedFormGroup({
      filename: new FormControl(''),
    });
    this.form = formGroup;

    this.beforePrintPrompt = this.data.beforePrintPrompt;
    this.hintText = this.data.subtext ? this.data.subtext : this.hintText;
    this.notesPlaceholder = this.data.placeholder || this.notesPlaceholder;

    if (!this.data.hideDetails) {
      this.form.addControl('details', new FormControl(''));
    }

    if (!this.data.hideVaDetails) {
      this.form.addControl('vaDetails', new FormControl(''));
    }

    if (
      this.includeNotes &&
      (this.app === 'li' || this.app === 'rw' || this.app === 'pp')
    ) {
      this.form.addControl('notes', new FormControl(''));
      this.form.controls.notes.setValue(this.data.printNote);
    }
  }

  save() {
    if (this.data.hideDetails && this.app === 'aw') {
      this.form.value.details = true;
    }

    this.dialogRef.close(this.form.value);
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }

  cancel() {
    this.dialogRef.close('cancel');
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }
}
